import '@reach/dialog/styles.css'

import { Dialog } from '@reach/dialog'
import { Form, Formik } from 'formik'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components/macro'

import { useIsDesktop } from '../../utils/useBreakpoint'
import Button from './Button'
import FormButtons from './FormButtons'

const StyledModal = styled(Dialog)`
  border-radius: 0.375em;
  padding: 23px 17px;
  width: 80%;
  max-width: 800px;
  margin: 8vh auto;

  h3 {
    margin-block-start: 0;
  }
`

const Modal = ({
  title,
  onDismiss,
  initialValues,
  validationSchema,
  onSubmit,
  children,
  initialDirty = false,
  ...props
}) => {
  const isDesktop = useIsDesktop()
  const { t } = useTranslation()

  return (
    <StyledModal
      aria-label={`${title} dialog`}
      onDismiss={onDismiss}
      isDesktop={isDesktop}
      {...props}
    >
      <h3>{title}</h3>

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        initialStatus={{ dirty: initialDirty }}
      >
        {(props) => {
          const { dirty, isSubmitting, isValid, status } = props
          const isDirty = dirty || status.dirty

          return (
            <Form>
              {children}
              <FormButtons align={'end'}>
                <Button type="button" onClick={onDismiss} secondary>
                  {t('form.button.cancel')}
                </Button>
                <Button
                  disabled={!isDirty || isSubmitting || !isValid}
                  type="submit"
                >
                  {isSubmitting
                    ? t('form.button.submitting')
                    : t('form.button.submit')}
                </Button>
              </FormButtons>
            </Form>
          )
        }}
      </Formik>
    </StyledModal>
  )
}

export default Modal
